import type { Visit } from '../api/types';
import { fmt, eL } from '../utils/format';
import { abrirVisita } from '../store/actions/visit.actions';

export function VisitsTable({ list }: { list: Visit[] }) {
  return (
    <table class="desktop-table">
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Técnico</th>
          <th>Programada</th>
          <th>Tipo</th>
          <th>Estado</th>
          <th>Ticket</th>
        </tr>
      </thead>
      <tbody>
        {list.map((v) => (
          <tr key={v.id} onClick={() => abrirVisita(v.id)}>
            <td>
              <strong>{v.client?.nombre}</strong>
            </td>
            <td>
              {v.tecnico ? v.tecnico.nombre : <em style={{ color: 'var(--warning)' }}>Sin tomar</em>}
            </td>
            <td>{fmt(v.fechaProgramada)}</td>
            <td>
              {v.tipo === 'emergencia' ? (
                <span class="badge" style={{ background: '#FCEBEB', color: 'var(--danger)' }}>
                  Emerg.
                </span>
              ) : (
                'Prog.'
              )}
            </td>
            <td>
              <span class={'badge estado-' + v.estado}>{eL(v.estado)}</span>
            </td>
            <td>{v.numeroTicket || '-'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
